export const navbarItems = {
  admin: [
    {
      label: "Your Account",
      icon: "bx bx-user-circle",
      path: "/account-setting/account",
    },
    {
      label: "Change Password",
      icon: "bx bx-lock",
      path: "/account-setting/security",
    },
  ],
  member: [
    {
      label: "My Profile",
      icon: "bx bx-user",
      path: "/account-setting/account",
    },
    {
      label: "Settings",
      icon: "bx bx-cog",
      path: "/account-setting/account",
    },
  ],
  doctor: [
    {
      label: "My Profile",
      icon: "bx bx-user",
      path: "/account-setting/account",
    },
    {
      label: "Settings",
      icon: "bx bx-cog",
      path: "/account-setting/account",
    },
    {
      label: "Pricing",
      icon: "bx bx-dollar",
      path: "/account-setting/account",
    },
  ],
};
